import React from 'react';

import { Switch, Route } from 'react-router-dom';
import { menuItemFilter, routeList, cerrarSesion } from '../../routes/routeList.js';
import NotFound from '../../pages/NotFound';

const isAllowed = (route) =>
    !Object.keys(menuItemFilter).includes(route.id) || menuItemFilter[route.id];

const MainView = () => {
    return (
        <Switch>
            {routeList.filter(isAllowed).map((route) => {
                if (!route.children) {
                    return (
                        <Route exact path={route.path} key={route.id} component={route.component} />
                    );
                } else {
                    return route.children.map((subroute) => (
                        <Route
                            exact
                            path={subroute.path}
                            key={subroute.id}
                            component={subroute.component}
                        />
                    ));
                }
            })}
            {cerrarSesion.map((route) => {
                if (!route.children) {
                    return (
                        <Route exact path={route.path} key={route.id} component={route.component} />
                    );
                } else {
                    return route.children.map((subroute) => (
                        <Route
                            exact
                            path={subroute.path}
                            key={subroute.id}
                            component={subroute.component}
                        />
                    ));
                }
            })}
            <Route component={NotFound} />
        </Switch>
    );
};

export default MainView;
